<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
        <g id="tourism" transform="translate(-55.258 484.38)">
	<path id="Path_70014" class="st0" d="M121.2-457.4c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0,0v-18.8c0-0.2-0.1-0.3-0.3-0.3c0,0,0,0,0,0
		h-2.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h2.1v18.1h-9.1c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.6
		v1.1H108c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.2,0,0.3-0.2,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3h-1v-18.1h8
		c0.2,0,0.3-0.2,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3H108c-0.7,0-1.2,0.5-1.2,1.2v18.8c0,0.7,0.5,1.2,1.2,1.2h7.4v1c0,0.2,0.1,0.3,0.3,0.3
		c0.1,0,0.1,0,0.2,0l1-0.5l1,0.5c0.2,0.1,0.4,0,0.4-0.1c0,0,0-0.1,0-0.2v-1h2.9c0.2,0,0.3-0.2,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3h-0.3
		v-1.1H121.2z M108-476.2h0.5v18.1H108c-0.2,0-0.4,0-0.5,0.1v-17.7C107.4-476,107.7-476.2,108-476.2L108-476.2z M117.6-455.3
		l-0.7-0.4c-0.1-0.1-0.2-0.1-0.3,0l-0.7,0.4v-2.2h1.7V-455.3z M120.2-456.4h-1.9v-1.1h1.9V-456.4z"/>
            <path id="Path_70015" class="st0" d="M118.3-462.3c0-0.2-0.1-0.3-0.3-0.3h-6.2c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3
		c0,0,0,0,0,0h6.2C118.2-462,118.3-462.1,118.3-462.3C118.3-462.3,118.3-462.3,118.3-462.3z"/>
            <path id="Path_70016" class="st0" d="M113.4-461.3c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.1
		c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c0,0,0,0,0,0H113.4z"/>
            <path id="Path_70017" class="st0" d="M114.9-473.8c-2.2,0-4,1.8-4,4c0,1.8,1.1,3.3,2.8,3.8l0.9,1.9c0.1,0.2,0.3,0.2,0.4,0.1
		c0.1,0,0.1-0.1,0.1-0.1l0.9-1.9c2.1-0.7,3.3-3,2.6-5.1C118.2-472.7,116.7-473.8,114.9-473.8L114.9-473.8z M115.8-466.5
		c-0.1,0-0.2,0.1-0.2,0.2l-0.7,1.4l-0.7-1.4c0-0.1-0.1-0.1-0.2-0.2c-1.8-0.5-2.8-2.4-2.3-4.2c0.5-1.8,2.4-2.8,4.2-2.3
		c1.8,0.5,2.8,2.4,2.3,4.2C117.9-467.7,117-466.8,115.8-466.5L115.8-466.5z"/>
            <path id="Path_70018" class="st0" d="M114.9-471.5c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8
		C116.7-470.7,115.9-471.5,114.9-471.5z M114.9-468.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1
		C116-469.1,115.5-468.6,114.9-468.6L114.9-468.6z"/>
</g>
        <g>
	<circle id="Ellipse_185" class="st1" cx="15" cy="12.5" r="12.5"/>
            <g>
		<path class="st0" d="M24.7,7.9c-0.1-0.1-0.1-0.1-0.2-0.1h-9.7c-1.1,0-2,0.9-2,2v17.7c0,1.1,0.9,2,2,2h12.3c1.1,0,2-0.9,2-2v-15
			c0-0.1,0-0.1-0.1-0.2l0,0L24.7,7.9z M24.8,8.8l3.4,3.4h-3.4V8.8z M28.6,27.6c0,0.8-0.7,1.5-1.5,1.5H14.8c-0.8,0-1.5-0.7-1.5-1.5
			V9.9c0-0.8,0.7-1.5,1.5-1.5h9.4v4.1c0,0.2,0.1,0.3,0.3,0.3h4.1V27.6z"/>
                <path class="st0" d="M24.9,24.5c0.9-1.3,1.4-2.8,1.4-4.4v-4.3c0-0.2-0.1-0.3-0.3-0.3c-1.1,0-2.1-0.6-2.6-1.6l-0.1-0.2
			c-0.1-0.1-0.2-0.2-0.3-0.2h-4c-0.1,0-0.2,0.1-0.3,0.2l-0.1,0.2c-0.5,1-1.5,1.6-2.6,1.6c-0.2,0-0.3,0.1-0.3,0.3v4.3
			c0,1.6,0.5,3.1,1.4,4.4c0.9,1.3,2.2,2.2,3.8,2.6c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0C22.6,26.7,23.9,25.8,24.9,24.5z M20.9,26.5
			c-2.7-0.9-4.5-3.5-4.5-6.3v-3.9l0.3-0.1c1-0.2,1.9-0.8,2.4-1.7l0.1-0.2h3.6l0.1,0.2c0.5,0.9,1.4,1.5,2.4,1.7l0.3,0.1v3.9
			c0,2.9-1.8,5.4-4.5,6.3l-0.1,0L20.9,26.5z"/>
                <path class="st0" d="M23.7,18.5c-0.1-0.1-0.2-0.1-0.3-0.1s-0.2,0-0.3,0.1h0l-3,3l-1.4-1.4C18.8,20,18.7,20,18.6,20s-0.2,0-0.3,0.1
			c-0.1,0.1-0.1,0.4,0,0.5l1.6,1.6c0.1,0.1,0.4,0.1,0.5,0l3.2-3.2C23.8,18.9,23.8,18.6,23.7,18.5z"/>
	</g>
</g>
</svg>
</template>

<script>
    export default {
        name: "IPrivacy"
    }
</script>

<style scoped>
    .st0 {
        fill: #799CFB;
    }

    .st1 {
        fill: #CEDBFF;
    }
</style>
